const DELETED_OPACITY = 0.5;
const DEFAULT_OPACITY = 1;

export const deletedStyle = (deleted: boolean) => deleted ? DELETED_OPACITY : DEFAULT_OPACITY;